import React, {Component, Fragment} from "react";
import {formatDate} from "../../../shared/services/utils/utils";
import classNames from "classnames";
import Select from "react-select";

class TrainingNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: [],
      selectedPhase: null
    }
  }

  componentDidMount() {

  }

  get trainingNotes() {
    if(this.state.selectedPhase) {
      return this.props.trainingNotes.filter(tn => {
        return tn.trainingPhase.guid === this.state.selectedPhase.value
      })
    }
    return this.props.trainingNotes
  }

  render() {
    return (
      <div>
       <div style={{ padding: '20px', display: 'flex'}}>
         <button
           data-tip="Add comment"
           className="button small primary"
           onClick={() => this.props.onAddNotes()}
         >
           <span>Add comment </span>
           <i className="fa fa-plus"/>
         </button>
         <Select
           styles={{container: (baseStyles, state) => ({
               ...baseStyles,
               flex: 1,
               marginLeft: '15px'
             })}}
           placeholder={'Select phase'}
           value={this.state.selectedPhase}
           isClearable={true}
           isSearchable={true}
           defaultValue={null}
           options={this.props.trainingTracker.trainingPhases.map(p => ({
             value: p.trainingPhaseGuid,
             label: p.header
           }))}
           name="phase"
           onChange={(e) => {this.setState({selectedPhase: e}); }}
         ></Select>
       </div>

        <div>{
          this.trainingNotes.map(n => <div style={{padding: '0 20px 20px 20px'}} key={n.id}>
            {this.props.userContext.userGuid === n.user.userGuid && <div>
              {/*<button*/}
              {/*  data-tip="Edit note below"*/}
              {/*  className="button small secondary"*/}
              {/*  onClick={() => this.props.onEditNote(n)}*/}
              {/*>*/}
              {/*  <i className="fa fa-pencil"/>*/}
              {/*</button>*/}

              <button
                data-tip="Delete comment bellow"
                className="button small danger"
                onClick={() => this.props.deleteNote(n)}
              >
                <i className="fa fa-trash"/>
              </button>
            </div>}
            <div><b>Date: </b>{formatDate(n.inserted_at)}</div>
            <div><b>Author: </b>{n.user.lastName} {n.user.firstName}</div>
            <div><b>Category: </b>{n.category}</div>
            <div><b>Phase: </b>{n.trainingPhase.header}</div>
            <div><b>Week: </b>{n.week}</div>
            <div><b>Comments: </b></div>
            <div style={{
              whiteSpace: "pre-line",
              unicodeBidi: "embed"
            }}>{n.comment}</div>
          </div>)
        }</div>
      </div>

    )
  }
}

export default TrainingNotes
